module.exports = __webpack_public_path__ + "img/44.7b9fa95b.png";